import { Locale, type LocalizedString } from "../Locale.js";
import { type ProductType, productTypeSlugMap } from "../ProductType.js";
import { sameValueForEveryLocale } from "../../utils/sameValueForEveryLocale.js";
import { productsPathMap } from "./productsPathMap.js";

export function getProductsByTypePath(type: ProductType): LocalizedString {
	return Object.values(Locale).reduce<LocalizedString>((acc, locale) => {
		acc[locale] = `${productsPathMap[locale]}/${productTypeSlugMap[type][locale]}`;
		return acc;
	}, sameValueForEveryLocale(""));
}
